import { createContext, useContext } from "react";
import { toast } from "./toast";

type ToastContextValue = {
  toast: typeof toast;
};

export const ToastContext = createContext<ToastContextValue | null>(null);

export function useToast(): ToastContextValue {
  const context = useContext(ToastContext);

  if (!context) {
    return { toast };
  }

  return context;
}
